'use client';

import React from 'react';
import Link from 'next/link';
import { useLanguage } from '@/context/LanguageContext';

export default function PermitBanner() {
  const { t } = useLanguage();

  return (
    <section className="py-8" style={{ background: 'linear-gradient(90deg, #0B2C4A 0%, #0E3A60 50%, #0B2C4A 100%)' }}>
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-5">
          <div className="flex items-start gap-4">
            <div
              className="w-11 h-11 rounded-xl flex items-center justify-center shrink-0"
              style={{ background: 'rgba(42,155,173,0.16)', border: '1.5px solid rgba(42,155,173,0.4)' }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="#2A9BAD">
                <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z" />
              </svg>
            </div>
            <div>
              <div className="font-semibold text-white text-base leading-snug">
                {t('home.permit.title')}
              </div>
              <div className="text-sm mt-1" style={{ color: 'rgba(255,255,255,0.65)' }}>
                {t('home.permit.subtitle')}{' '}
                <span className="font-mono" style={{ color: '#7FE3F0' }}>IFTP00104977</span>
              </div>
            </div>
          </div>

          <Link
            href="/compliance"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold text-sm whitespace-nowrap transition-all duration-300"
            style={{ background: 'rgba(42,155,173,0.15)', color: '#7FE3F0', border: '1px solid rgba(42,155,173,0.45)' }}
          >
            {t('home.permit.cta')}
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
}
